import React from "react";
import { ReactComponent as Abstract } from "assets/img/vectors/homepage/abstract-5.svg";


const Abstract5 = () => (
    <Abstract />
)

export default Abstract5;